import { render, staticRenderFns } from "./leftMiddle.vue?vue&type=template&id=681bf0ca&scoped=true&"
import script from "./leftMiddle.vue?vue&type=script&lang=js&"
export * from "./leftMiddle.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "681bf0ca",
  null
  
)

export default component.exports